import classNames from 'classnames';
import styled from 'styled-components';
import { NEUTRAL_500 } from 'visitor-ui-component-library/constants/WidgetColors';
import VizExSmall from 'visitor-ui-component-library/typography/VizExSmall';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledBorder = styled.div.withConfig({
  displayName: "DashedLabel__StyledBorder"
})(["display:flex;flex-grow:1;border:solid 1px ", ";"], NEUTRAL_500);
function DashedLabel({
  children,
  transparent,
  ['data-test-id']: data,
  labelPadding
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('display-flex align-end', labelPadding, transparent && 'justify-center', !labelPadding && 'm-y-6'),
    "data-test-id": data || 'dashed-label',
    tabIndex: 0,
    children: [!transparent && /*#__PURE__*/_jsx(StyledBorder, {
      "data-test-id": "styled-border",
      className: "m-bottom-3"
    }), /*#__PURE__*/_jsx("div", {
      className: "max-100 p-x-4",
      children: /*#__PURE__*/_jsx(VizExSmall, {
        use: "help",
        className: "m-bottom-1 align-center text-center word-break-break-word flex-column",
        children: children
      })
    }), !transparent && /*#__PURE__*/_jsx(StyledBorder, {
      "data-test-id": "styled-border",
      className: "m-bottom-3"
    })]
  });
}
DashedLabel.displayName = 'DashedLabel';
export default DashedLabel;